import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import PurchaseForm from "./PurchaseForm";

const CreatePurchaseOrder = () => {
  return (
    <div className="d-flex flex-column" style={{height:'100vh'}}>
      <Helmet>
        <title>Purchase Order - Create</title>
      </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <PurchaseForm />
      </div>
    </div>
  );
};

export default CreatePurchaseOrder;
